module.exports = __webpack_public_path__ + "static/media/weather.f6ca6406.gif";